import { z } from 'zod';
import { isUsPhoneNumber } from '@/utils/isUsPhoneNumber';

const timeString = z.string().optional().or(z.literal(''));

const breakSchema = z.object({
  from: timeString,
  to: timeString
});

const workingDaySchema = z.object({
  open: z.boolean().optional(),
  from_time: timeString,
  to_time: timeString,
  breaks: z.array(breakSchema).optional()
});

const workingHoursSchema = z.object({
  monday: workingDaySchema,
  tuesday: workingDaySchema,
  wednesday: workingDaySchema,
  thursday: workingDaySchema,
  friday: workingDaySchema,
  saturday: workingDaySchema,
  sunday: workingDaySchema
});

const holidaySchema = z.object({
  date: z.string().min(1, 'Date is required'),
  reason: z.string().optional().or(z.literal(''))
});

export const operatorSchema = z
  .object({
    operator: z.object({
      first_name: z.string().min(1, 'Name is required'),
      email: z.string().email('Please enter a valid email address').optional().nullish().or(z.literal('')),
      phone_number: z.string().optional().nullish().or(z.literal('')),
      sms_consent: z.boolean().optional(),
      sip_uri: z.any().optional(),
      extension: z.any().optional().nullish(),
      working_hours: workingHoursSchema.optional(),
      holidays: z.array(holidaySchema).optional()
    })
  })
  .refine((data) => data.operator.email?.trim() || data.operator.phone_number?.trim(), {
    message: 'Either email or phone number is required',
    path: ['operator', 'email']
  })
  .superRefine((data, ctx) => {
    if (isUsPhoneNumber(data.operator.phone_number) && data.operator.sms_consent !== true) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'SMS consent is required',
        path: ['operator', 'sms_consent']
      });
    }
  });
